var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2225 2.27748C11.5589 2.61381 11.5894 3.14013 11.3143 3.511L11.2225 3.61726L6.84021 8L11.2225 12.3827C11.5589 12.7191 11.5894 13.2454 11.3142 13.6163L11.2225 13.7225C10.8862 14.0589 10.3599 14.0894 9.989 13.8142L9.88274 13.7225L4.83011 8.66989C4.49377 8.33355 4.4632 7.80724 4.73838 7.43636L4.83011 7.33011L9.88274 2.27748C10.2527 1.90751 10.8526 1.90751 11.2225 2.27748Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLeftArrow);
export default __webpack_public_path__ + "static/media/calendar-left-arrow.4b3219c4d84ca4c086ebc094895af5e3.svg";
export { ForwardRef as ReactComponent };